module.exports = __webpack_public_path__ + "img/pay.67d6a7e4.svg";